import { render, staticRenderFns } from "./resourceDetailPurchase.vue?vue&type=template&id=c430f2fa&scoped=true"
import script from "./resourceDetailPurchase.vue?vue&type=script&lang=js"
export * from "./resourceDetailPurchase.vue?vue&type=script&lang=js"
import style0 from "./resourceDetailPurchase.vue?vue&type=style&index=0&id=c430f2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c430f2fa",
  null
  
)

export default component.exports